export const blockIconsHardwareCastNew = (
	<span className='material-symbols-outlined'>cast</span>
);
